module.exports = __webpack_public_path__ + "media/images/icons/outlined/skype-b7423218f9af1b688c73a93255e8cf6f.svg";